angular.module( 'acme.view.application.resources.personnel', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.resources.personnel.controllers',
  'acme.view.application.resources.personnel.list.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var resourcesPersonnel = {
        name: 'application.resources.personnel',
        url: '/personnel',
        abstract: true,
        views: {
          "subview-main": {
            controller: 'ResourcesPersonnelController',
            templateUrl: 'views/application/views/resources/personnel/personnel.tpl.html'
          }
        }
      },
      resourcesPersonnelDefault = {
        name: 'application.resources.personnel.list',
        url: '',
        views: {
          "subview-main": {
            controller: 'ResourcesPersonnelListController',
            templateUrl: 'views/application/views/resources/personnel/personnelList.tpl.html'
          }
        },
        data: {
          pageTitle: 'Personnel Manager',
          roles: ['admin']
        }
      };

    $stateProvider
      .state(resourcesPersonnel)
      .state(resourcesPersonnelDefault);
});
